import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/layout'
import HelpLayout from '../components/HelpLayout.vue'
import TestBuyerLayout from '../components/TestBuyerLayout.vue'

Vue.use(VueRouter)

const routes = [

  {
    // 英文版落地页
    path: '/',
    name: 'Welcome',
    component: () => import('@/views/LandingPageEn'),
    meta: { 
      title: 'BPS'
    },
  },{
    path: '/EN',
    name: 'LandingpageEn',
    component: () => import('@/views/LandingPageEn'),
    meta: { 
      title: 'BPS'
    },
  },{
    path: '/CN',
    name: 'Landingpage',
    component: () => import('@/views/LandingPage'),
    meta: { 
      title: 'BPS'
    },
  },{
    path: '/JP',
    name: 'LandingpageJp',
    component: () => import('@/views/LandingPageJp'),
    meta: { 
      title: 'BPS'
    },
  },{
    path: '/About',
    name: 'AboutUs',
    component: () => import('@/views/About'),
    meta: { 
      title: 'About'
    },
  },{
    // 登录
    path: '/Login',
    name: 'Login',
    component: () => import('@/views/Login'),
    meta: { 
      title: 'Login'
    },
  },{
    // 登录
    path: '/Login/Default',
    name: 'LoginDefault',
    component: () => import('@/views/LoginDefault'),
    meta: { 
      title: 'Login'
    },
  },{
    // 工单系统SSO登入
    path: '/Oauth',
    name: 'Oauth',
    component: () => import('@/views/SSO/Oauth'),
    meta: { 
      title: 'Oauth'
    },
  },{
    // 工单系统SSO登出
    path: '/SSOLogout',
    name: 'SSOLogout',
    component: () => import('@/views/SSO/SSOLogout'),
    meta: { 
      title: 'Logout'
    },
  },{
    // 找回密码
    path: '/LostPassword',
    name: 'LostPassword',
    component: () => import('@/views/LostPassword'),
    meta: { 
      title: 'Lost Password'
    },
  },{
    // 重置密码
    path: '/password',
    name: 'password',
    component: () => import('@/views/LostPassword'),
    meta: { 
      title: 'Lost Password'
    },
  },{
    // 价格监控
    path: '/PriceMonitoring',
    component: Layout,
    children: [{
      // 价格监控首页(统计+列表)
      path: ':Id',
      name: 'PriceMonitoringProduct',
      component: () => import('@/views/PriceMonitoring/Product.vue'),
      meta: {
        title: 'Price Monitor',
        menutitle: 'SidebarMenu.Menu02',
        menuclass: 'sidebar-pageicon-mybrand'
      }
    },{
      // 低价商品链接
      path: ':Id/LowPriced',
      name: 'LowPricedProductsLinks',
      component: () => import('@/views/PriceMonitoring/Lowpricelinks.vue'),
      meta: {
        title: 'Price Monitor',
        menutitle: 'SidebarMenu.Menu02',
        menuclass: 'sidebar-pageicon-mybrand'
      }
    },{
      // 低价商品链接详情
      path: ':Id/LowPriced/:Mid',
      name: 'ViewUrlDetail1',
      component: () => import('@/views/PriceMonitoring/ViewUrlDetail.vue'),
      meta: {
        title: 'Price Monitor',
        menutitle: 'SidebarMenu.Menu02',
        menuclass: 'sidebar-pageicon-mybrand'
      }
    },{
      path: ':Id/:SkuId',
      name: 'ViewUrl',
      component: () => import('@/views/PriceMonitoring/ViewUrl.vue'),
      meta: {
        title: 'Price Monitor',
        menutitle: 'SidebarMenu.Menu02',
        menuclass: 'sidebar-pageicon-mybrand'
      }
    },{
      path: ':Id/:SkuId/:Mid',
      name: 'ViewUrlDetail',
      component: () => import('@/views/PriceMonitoring/ViewUrlDetail.vue'),
      meta: {
        title: 'Price Monitor',
        menutitle: 'SidebarMenu.Menu02',
        menuclass: 'sidebar-pageicon-mybrand'
      }
    }]
  },{
    // 卖家详情
    path: '/Seller',
    component: Layout,
    children: [{
      path: ':Id/Inactive',
      name: 'SellerInactive',
      component: () => import('@/views/Intro/Seller.vue'),
      meta: {
        title: 'Seller Analysis',
        menutitle: 'SidebarMenu.Menu02',
        menuclass: 'sidebar-pageicon-mybrand'
      }
    },{
      path: ':Id',
      name: 'PriceMonitoringSeller',
      component: () => import('@/views/Seller/Overview.vue'),
      meta: {
        title: 'Seller Analysis',
        menutitle: 'SidebarMenu.Menu02',
        menuclass: 'sidebar-pageicon-mybrand'
      }
    },{
      path: ':Id/:Sid',
      name: 'SellerDetail',
      component: () => import('@/views/Seller/Detail.vue'),
      meta: {
        title: 'Seller Analysis',
        menutitle: 'SidebarMenu.Menu02',
        menuclass: 'sidebar-pageicon-mybrand'
      }
    }]
  },{
    // PDF月报下载模板 商品月报
    path: '/qwS8caqsi9svzjfS/DownloadSellerPDF/:ShopId/:SubId/:Lan',
    name: 'DownloadSellerPDF',
    component: () => import('@/views/Seller/DownloadSellerPDF.vue'),
    meta: {
      title: 'Seller Analysis'
    }
  },{
    // 侵权商品
    path: '/Infringements',
    component: Layout,
    children: [{
      path: ':Id/Inactive',
      name: 'InfringementsInactive',
      component: () => import('@/views/Intro/Infringements.vue'),
      meta: {
        title: 'Infringements',
        menutitle: 'SidebarMenu.Menu02',
        menuclass: 'sidebar-pageicon-mybrand'
      }
    },{
      path: ':Id',
      name: 'EcommerceDefenseProduct',
      component: () => import('@/views/Infringements/Product.vue'),
      meta: {
        title: 'Infringements',
        menutitle: 'SidebarMenu.Menu02',
        menuclass: 'sidebar-pageicon-mybrand'
      }
    },{
      path: ':Id/Links',
      name: 'EcommerceDefenseShowLinks',
      component: () => import('@/views/Infringements/ShowLinks.vue'),
      meta: {
        title: 'Infringements',
        menutitle: 'SidebarMenu.Menu02',
        menuclass: 'sidebar-pageicon-mybrand'
      }
    },{
      path: ':Id/:SkuId',
      name: 'EcommerceDefenseProductUrl',
      component: () => import('@/views/Infringements/ViewUrl.vue'),
      meta: {
        title: 'Infringements',
        menutitle: 'SidebarMenu.Menu02',
        menuclass: 'sidebar-pageicon-mybrand'
      }
    }]
  },{
    // 关键指标
    path: '/Metrics',
    component: Layout,
    children: [{
      path: ':Id/Inactive',
      name: 'MetricsInactive',
      component: () => import('@/views/Intro/Metrics.vue'),
      meta: {
        title: 'Metrics',
        menutitle: 'SidebarMenu.Menu02',
        menuclass: 'sidebar-pageicon-mybrand'
      }
    },{
      path: ':Id',
      name: 'Metrics',
      component: () => import('@/views/Metrics/Overview.vue'),
      meta: {
        title: 'Metrics',
        menutitle: 'SidebarMenu.Menu02',
        menuclass: 'sidebar-pageicon-mybrand'
      }
    }]
  },{
    // 投诉管理
    path: '/Takedowns',
    component: Layout,
    children: [{
      path: ':Id/Inactive',
      name: 'TakedownsInactive',
      component: () => import('@/views/Intro/TakeDowns.vue'),
      meta: {
        title: 'Takedowns',
        menutitle: 'SidebarMenu.Menu97',
        menuclass: 'sidebar-pageicon-mybrand'
      }
    },{
      path: ':Id',
      name: 'Takedowns',
      component: () => import('@/views/TakeDowns/Index.vue'),
      meta: {
        title: 'Takedowns',
        menutitle: 'SidebarMenu.Menu97',
        menuclass: 'sidebar-pageicon-mybrand'
      }
    }]
  },{
    // 导入管理
    path: '/Import',
    component: Layout,
    children: [{
      path: ':Id/Inactive',
      name: 'ImportInactive',
      component: () => import('@/views/Intro/Import.vue'),
      meta: {
        title: 'Import',
        menutitle: '导入管理',
        menuclass: 'sidebar-pageicon-mybrand'
      }
    },{
      path: ':Id',
      name: 'Import',
      component: () => import('@/views/Import/Index.vue'),
      meta: {
        title: 'Import',
        menutitle: '导入管理',
        menuclass: 'sidebar-pageicon-mybrand'
      }
    }]
  },{
    // 促销管理
    path: '/Campaign',
    component: Layout,
    children: [{
      path: ':Id',
      name: 'Campaign',
      component: () => import('@/views/Campaign/Index.vue'),
      meta: {
        title: 'Promotion',
        menutitle: '促销管理',
        menuclass: 'sidebar-pageicon-mybrand'
      }
    },{
      path: ':Id/:Pid/MP',
      name: 'CampaignDetailMP',
      component: () => import('@/views/Campaign/Detail.vue'),
      meta: {
        title: 'Promotion',
        menutitle: '促销管理',
        menuclass: 'sidebar-pageicon-mybrand'
      }
    },{
      path: ':Id/CP',
      name: 'CampaignDetailCP',
      component: () => import('@/views/Campaign/NormalPrice.vue'),
      meta: {
        title: 'Promotion',
        menutitle: '促销管理',
        menuclass: 'sidebar-pageicon-mybrand'
      }
    }]
  },{
    // 个人中心
    path: '/Personal',
    component: Layout,
    redirect: '/Personal/Profile',
    name: '',
    meta: { 
      title: 'Profile'
    },
    children: [{
      path: 'Profile/:Id',
      name: 'Profile',
      component: () => import('@/views/Personal/Profile.vue'),
      meta: {
        title: 'Profile',
        menutitle: 'SidebarMenu.Menu08',
        menuclass: 'sidebar-pageicon-profile'
      }
    },{
      path: 'MyVip/:Id',
      name: 'MyVip',
      component: () => import('@/views/Personal/MyVip.vue'),
      meta: {
        title: 'MyVip',
        menutitle: 'SidebarMenu.Menu02',
        menuclass: 'sidebar-pageicon-myvip'
      }
    },{
    //   path: 'IPP/:Id',
    //   name: 'IPP',
    //   component: () => import('@/views/Personal/IPP.vue'),
    //   meta: {
    //     title: 'IPP',
    //     menutitle: 'IPP',
    //     menuclass: 'sidebar-pageicon-myvip'
    //   }
    // },{
      path: 'Report/:Id',
      name: 'Report',
      component: () => import('@/views/Personal/Report.vue'),
      meta: {
        title: 'Report',
        menutitle: 'SidebarMenu.Menu10',
        menuclass: 'sidebar-pageicon-myvip'
      }
    },{
      path: 'Inbox/:Id',
      name: 'Inbox',
      component: () => import('@/views/Personal/Inbox.vue'),
      meta: {
        title: 'Inbox',
        menutitle: 'SidebarMenu.Menu11',
        menuclass: 'sidebar-pageicon-inbox'
      }
    },{
      path: 'ReportSetting/:Id',
      name: 'ReportSetting',
      component: () => import('@/views/Personal/ReportSetting.vue'),
      meta: {
        title: 'Report Setting',
        menutitle: 'SidebarMenu.Menu12',
        menuclass: 'sidebar-pageicon-inbox'
      }
    },{
      path: 'ModelSetting/:Id',
      name: 'ModelSetting',
      component: () => import('@/views/Personal/ModelSetting.vue'),
      meta: {
        title: 'Model Setting',
        menutitle: '浏览设定',
        menuclass: 'sidebar-pageicon-inbox'
      }
    },{
      path: 'Notifications/:Id',
      name: 'Notifications',
      component: () => import('@/views/Personal/Notifications.vue'),
      meta: {
        title: 'Notifications Setting',
        menutitle: '通知设定',
        menuclass: 'sidebar-pageicon-inbox'
      }
    },{
      path: 'CouponSetting/:Id',
      name: 'CouponSetting',
      component: () => import('@/views/Personal/CouponSetting.vue'),
      meta: {
        title: 'Coupon Setting',
        menutitle: '优惠券设定',
        menuclass: 'sidebar-pageicon-inbox'
      }
    },{
      path: 'SKUSetting/:Id',
      name: 'SKUSetting',
      component: () => import('@/views/Personal/SKUSetting.vue'),
      meta: {
        title: 'SKU Setting',
        menutitle: 'SKU设定',
        menuclass: 'sidebar-pageicon-inbox'
      }
    },{
      path: 'DiscountSetting/:Id',
      name: 'DiscountSetting',
      component: () => import('@/views/Personal/DiscountSetting.vue'),
      meta: {
        title: 'Coupon Setting',
        menutitle: '折扣设置',
        menuclass: 'sidebar-pageicon-inbox'
      }
    }]
  },{
    // 帮助中心
    path: '/Help',
    component: HelpLayout,
    redirect: '/Help/OperationManual',
    name: '',
    meta: { 
      title: 'OperationManual'
    },
    children: [{
      path: 'OperationManual',
      name: 'OperationManual',
      component: () => import('@/views/Help/OperationManual.vue'),
      meta: {
        title: 'OperationManual'
      }
    },{
      path: 'FAQ',
      name: 'FAQ',
      component: () => import('@/views/Help/FAQ.vue'),
      meta: {
        title: 'FAQ'
      }
    }]
  },{
    // 关键指标PDF报告下载
    path: '/qwS8caqsi9svzjfS/DownloadMetricsReport/:SubId/:Type/:Month/:Lan/:Level',
    name: 'DownloadMetricsReport',
    component: () => import('@/views/Report/Metrics.vue'),
    meta: { 
      title: 'Download Metrics Report'
    },
  },
  {
    // SPU - 价格监控
    path: '/SPU/PriceMonitoring',
    component: Layout,
    children: [{
      // 价格监控首页(统计+列表)
      path: ':Id',
      name: 'SPUPriceMonitoringProduct',
      component: () => import('@/views/SPU/PriceMonitoring/Index.vue'),
      meta: {
        title: 'Price Monitor',
        menutitle: 'SidebarMenu.Menu02',
        menuclass: 'sidebar-pageicon-mybrand'
      }
    },{
      // 低价商品链接
      path: ':Id/LowPriced',
      name: 'SPULowPricedProductsLinks',
      component: () => import('@/views/SPU/PriceMonitoring/LowPricedProductsLinks.vue'),
      meta: {
        title: 'Price Monitor',
        menutitle: 'SidebarMenu.Menu02',
        menuclass: 'sidebar-pageicon-mybrand'
      }
    },{
      // 低价商品链接详情
      path: ':Id/LowPriced/:Mid',
      name: 'SPUViewUrlDetail1',
      component: () => import('@/views/SPU/PriceMonitoring/ViewUrlDetail.vue'),
      meta: {
        title: 'Price Monitor',
        menutitle: 'SidebarMenu.Menu02',
        menuclass: 'sidebar-pageicon-mybrand'
      }
    },{
      path: ':Id/:SkuId',
      name: 'SPUViewUrl',
      component: () => import('@/views/SPU/PriceMonitoring/ViewUrl.vue'),
      meta: {
        title: 'Price Monitor',
        menutitle: 'SidebarMenu.Menu02',
        menuclass: 'sidebar-pageicon-mybrand'
      }
    },{
      path: ':Id/:SkuId/:Mid',
      name: 'SPUViewUrlDetail',
      component: () => import('@/views/SPU/PriceMonitoring/ViewUrlDetail.vue'),
      meta: {
        title: 'Price Monitor',
        menutitle: 'SidebarMenu.Menu02',
        menuclass: 'sidebar-pageicon-mybrand'
      }
    }]
  },{
    // SPU 侵权商品
    path: '/SPU/Infringements',
    component: Layout,
    children: [{
      path: ':Id',
      name: 'SPUEcommerceDefenseProduct',
      component: () => import('@/views/SPU/Infringements/Product.vue'),
      meta: {
        title: 'Infringements',
        menutitle: 'SidebarMenu.Menu02',
        menuclass: 'sidebar-pageicon-mybrand'
      }
    },{
      path: ':Id/Links',
      name: 'SPUEcommerceDefenseShowLinks',
      component: () => import('@/views/SPU/Infringements/ShowLinks.vue'),
      meta: {
        title: 'Infringements',
        menutitle: 'SidebarMenu.Menu02',
        menuclass: 'sidebar-pageicon-mybrand'
      }
    },{
      path: ':Id/:SkuId',
      name: 'SPUEcommerceDefenseProductUrl',
      component: () => import('@/views/SPU/Infringements/ViewUrl.vue'),
      meta: {
        title: 'Infringements',
        menutitle: 'SidebarMenu.Menu02',
        menuclass: 'sidebar-pageicon-mybrand'
      }
    }]
  },{
    // SPU 卖家详情
    path: '/SPU/Seller',
    component: Layout,
    children: [{
      path: ':Id',
      name: 'SPUPriceMonitoringSeller',
      component: () => import('@/views/Seller/Overview.vue'),
      meta: {
        title: 'Seller Analysis',
        menutitle: 'SidebarMenu.Menu02',
        menuclass: 'sidebar-pageicon-mybrand'
      }
    },{
      path: ':Id/:Sid',
      name: 'SPUSellerDetail',
      component: () => import('@/views/Seller/Detail.vue'),
      meta: {
        title: 'Seller Analysis',
        menutitle: 'SidebarMenu.Menu02',
        menuclass: 'sidebar-pageicon-mybrand'
      }
    }]
  },{
    // 关键指标
    path: '/SPU/Metrics',
    component: Layout,
    children: [{
      path: ':Id',
      name: 'SPUMetrics',
      component: () => import('@/views/SPU/Metrics/Overview.vue'),
      meta: {
        title: 'Metrics',
        menutitle: 'SidebarMenu.Menu02',
        menuclass: 'sidebar-pageicon-mybrand'
      }
    }]
  },{
    // 暂无数据
    path: '/DataPending',
    component: Layout,
    children: [{
      path: ':Id',
      name: 'DataPending',
      component: () => import('@/components/Commons/DataPending.vue'),
      meta: {
        title: 'Data Pending',
        menutitle: 'SidebarMenu.Menu02',
        menuclass: 'sidebar-pageicon-mybrand'
      }
    }]
  },{
    // 微信授权
    path: '/WechatAuthorize',
    name: 'WechatAuthorize',
    component: () => import('@/views/WechatAuthorize.vue'),
    meta: { 
      title: 'Wechat'
    },
  },{
    // 测买管理
    path: '/Testbuy',
    component: Layout,
    children: [{
      path: ':Id/Inactive',
      name: 'TestbuyInactive',
      component: () => import('@/views/Intro/Testbuy.vue'),
      meta: {
        title: 'Testbuy',
        menutitle: 'SidebarMenu.Menu87',
        menuclass: 'sidebar-pageicon-mybrand'
      }
    },{
      path: ':Id',
      name: 'Testbuy',
      component: () => import('@/views/Testbuy/Index.vue'),
      meta: {
        title: 'Testbuy',
        menutitle: 'SidebarMenu.Menu87',
        menuclass: 'sidebar-pageicon-mybrand'
      }
    },{
      path: ':Id/:Testid/Edit',
      name: 'TestbuyEdit',
      component: () => import('@/views/Testbuy/EditTestbuy.vue'),
      meta: {
        title: 'Testbuy',
        menutitle: 'SidebarMenu.Menu87',
        menuclass: 'sidebar-pageicon-mybrand'
      }
    },{
      path: ':Id/Balance',
      name: 'TestbuyBalance',
      component: () => import('@/views/Testbuy/Balance.vue'),
      meta: {
        title: 'Testbuy',
        menutitle: 'SidebarMenu.Menu87',
        menuclass: 'sidebar-pageicon-mybrand'
      }
    },{
      path: ':Id/:Testid/Report',
      name: 'TestbuyReport',
      component: () => import('@/views/Testbuy/Report.vue'),
      meta: {
        title: 'Testbuy',
        menutitle: 'SidebarMenu.Menu87',
        menuclass: 'sidebar-pageicon-mybrand'
      }
    }]
  },{
    // 测买管理下载报告
    path: '/qwS8caqsi9svzjfS/:Taskid/:Assetid/Report',
    name: 'TestbuyReportDownload',
    component: () => import('@/views/Testbuy/ReportDownload.vue'),
    meta: {
      title: 'Testbuy',
    }
  },{
    // 买手登录
    path: '/TestBuyer',
    component: TestBuyerLayout,
    children: [{
      path: 'Index',
      name: 'TestBuyerHomePgae',
      component: () => import('@/views/TestBuyer/TestBuyerHomePage.vue'),
      meta: {
        title: 'Test Buyer',
      }
    },{
      path: 'Detail/:taskId/:testId',
      name: 'TestBuyerDetail',
      component: () => import('@/views/TestBuyer/TestBuyerDetail.vue'),
      meta: {
        title: 'Test Buyer',
      }
    }]
  },{
    // 链接状态
    path: '/Linkstatus',
    component: Layout,
    children: [{
      path: ':Id/Inactive',
      name: 'LinkstatusInactive',
      component: () => import('@/views/Intro/Linkstatus.vue'),
      meta: {
        title: 'Link Status',
        menutitle: 'SidebarMenu.linkstatus',
        menuclass: 'sidebar-pageicon-mybrand'
      }
    },{
      path: ':Id',
      name: 'Linkstatus',
      component: () => import('@/modules/linkstatus/Index.vue'),
      meta: {
        title: 'Link Status',
        menutitle: 'SidebarMenu.linkstatus',
        menuclass: 'sidebar-pageicon-mybrand'
      }
    }]
  }

]

const routerPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error=> error)
}

const router = new VueRouter({
  routes
})

export default router
